import { render, staticRenderFns } from "./Mouth2.vue?vue&type=template&id=aa13ec92&"
import script from "./Mouth2.vue?vue&type=script&lang=js&"
export * from "./Mouth2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports